module.exports = __webpack_public_path__ + "static/media/shortcut_guide.a9eea802.png";